var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-admin-wrap layout-sidebar-large clearfix"},[_c('div',{staticClass:"main-content-wrap d-flex flex-column m-0"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }